<template>
    <div id="app">
        <div class="top">
            <m-header title="购物袋">
                <template v-if="validCartList.length > 0">
                    <div class="right" slot="right" v-show="!isEdit" @click="event_edit">编辑</div>
                    <div class="right" slot="right" v-show="isEdit" @click="event_editDone">完成</div>
                </template>
            </m-header>
            <transition name="slide" @after-enter="event_transitionend" @after-leave="event_transitionend">
                <!--顶部提示条（可用优惠券、满减等）-->
                <m-tips v-show="tipsText && isTipsShow" :tipsText="tipsText"></m-tips>
            </transition>
        </div>
        <div class="main" id="main">
            <div class="scroll-container">
                <!--购车商品列表页，有商品时显示-->
                <shopping-cart-list v-if="cartList && cartList.length > 0"></shopping-cart-list>
                <!--空购物车页-->
                <empty-shopping-cart v-if="cartList && cartList.length <= 0"></empty-shopping-cart>
                <!--猜你喜欢页-->
                <m-recommend></m-recommend>
            </div>
        </div>
        <div class="footer">
            <!--底部结算按钮，只有购物车中有商品时才显示-->
            <settlement-bar v-show="cartList.length > 0"></settlement-bar>
        </div>
        <transition name="fade">
            <!--税金的遮罩层-->
            <tax-mask v-show="isTaxMaskShow" :tax="cartData.tax"></tax-mask>
        </transition>
        <!--toast提示框-->
        <m-toast></m-toast>
        <!--loading状态提示-->
        <m-loading></m-loading>
        <m-dialog
            v-bind="{
                model: 'confirm',
                isShow: isConfirmShow,
                content: confirmData.content
            }"
            @emit_close="emit_alertClose"
            @emit_ok="emit_alertOk"
        ></m-dialog>
    </div>
</template>

<script>
    import MHeader from '@/components/MHeader';
    import MTips from '@/components/MTips';
    import SettlementBar from '@/components/SettlementBar';
    import TaxMask from '@/components/TaxMask';
    import MToast from '@/components/MToast';
    import MLoading from '@/components/MLoading';
    import MRecommend from '@/components/MRecommend';
    import ShoppingCartList from '@/pages/ShoppingCartList';
    import EmptyShoppingCart from '@/pages/EmptyShoppingCart';
    import MDialog from '@/components/MDialog';

    import {api_getShoppingCartData} from '@/api';

    import {handleResCartData} from '@/public/js/public.js';

    import {mapGetters, mapMutations} from 'vuex';

    import BScroll from 'better-scroll';

    export default {
        components: {
            MHeader,
            MTips,
            ShoppingCartList,
            EmptyShoppingCart,
            SettlementBar,
            TaxMask,
            MToast,
            MRecommend,
            MLoading,
            MDialog
        },
        data () {
            return {
                scroll: null
            };
        },
        computed: {
            ...mapGetters([
                'cartData',
                'cartList',
                'validCartList',
                'isTipsShow',
                'isTaxMaskShow',
                'upk',
                'isEdit',
                'isConfirmShow',
                'confirmData'
            ]),
            // 提示信息--没有选中商品，显示降价提示，有选中商品显示优惠券提示，没有优惠券提示显示降价提示
            tipsText() {
                // const cartData = this.cartData;
                const {checkedCommonTotalCount, cutPriceText, ticketText} = this.cartData;
                return checkedCommonTotalCount === 0 ? cutPriceText : ticketText || cutPriceText;
            }
        },
        created() {
            const _this = this;
            _this._initScroll();
            // 本地的购物车数据
            const localCartData = localStorage.getItem('cartData');
            // 如果没有upk并且本地存储没有购物车数据，则不调接口
            if (!_this.upk && !localCartData) {
                return;
            }
            _this._getShoppingCartData();
            // 监听pageshow事件，防止某些系统和浏览器从其他页面直接点返回，返回到本页面时缓存不刷新的情况
            window.addEventListener('pageshow', (e) => {
                // 如果e.persisted为true，则表明是从浏览器缓存中读取的
                if (e.persisted) {
                    _this._getShoppingCartData();
                }
            });
        },
        methods: {
            ...mapMutations({
                set_edit_true: 'SET_EDIT_TRUE',
                set_edit_false: 'SET_EDIT_FALSE',
                set_confirm_hide: 'SET_CONFIRM_HIDE'
            }),
            _initScroll () {
                const _this = this;
                _this.$nextTick(() => {
                    _this.scroll = new BScroll('#main', {
                        click: true,
                        bounce: {
                            left: false,
                            right: false
                        }
                    });
                });
            },
            // 获取购物车数据
            _getShoppingCartData() {
                const _this = this;
                let localCartData = localStorage.getItem('cartData');
                localCartData = JSON.parse(localCartData) || [];
                api_getShoppingCartData().then(({data}) => {
                    const {retCode, cart} = data;
                    if (retCode === 0) {
                        // 没有upk（没有登陆）并且购物车返回有商品列表，添加addFrom字段
                        if (!_this.upk && cart.cartItems && cart.cartItems.length > 0) {
                            cart.cartItems.forEach((item, index) => {
                                if (localCartData[index] && localCartData[index].productId === item.productId && localCartData[index].addFrom) {
                                    item.addFrom = localCartData[index].addFrom;
                                }
                            });
                        }
                        // 购物车列表数据
                        handleResCartData(cart);
                    }
                });
            },
            // 编辑
            event_edit () {
                this.set_edit_true();
            },
            event_transitionend () {
                this.scroll && this.scroll.refresh();
            },
            // 完成
            event_editDone () {
                this.set_edit_false();
            },
            emit_alertClose () {
                this.set_confirm_hide();
            },
            emit_alertOk () {
                this.confirmData.ok();
            }
        }
    };
</script>

<style lang="scss">
    @import './public/style/index.scss';

    #app,
    .footer {
        max-width: toRem(750);
    }

    #app {
        position: relative;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        height: 100%;
        /*font-family: Helvetica Neue, Tahoma, Arial, PingFangSC-Regular, Hiragino Sans GB, Microsoft Yahei, sans-serif;*/
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: $color-main;
        background-color: $color-bg;
        overflow: hidden;
    }

    .top {
        flex-shrink: 0;
        flex-grow: 0;
    }

    .main {
        flex: 1;
        overflow: hidden;
        background-color: #fff;
    }

    .scroll-container {
        background-color: $color-bg;
        overflow: auto;
    }

    .footer {
        width: 100%;
    }

    .slide-enter-active, .slide-leave-active {
        transition: height 0.2s;
        height: toRem(80);
    }

    .slide-enter, .slide-leave-to {
        height: 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.2s;
        opacity: 1;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue